export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPracovnikkat';
export const NAME = 'KategoriePracovnika';
export const MENU_CODE = 'KategoriePrac';
export enum ModuleName {
	Customers = 'Customers',
	Vehicles = 'Vehicles',
}

export enum TAB_NAMES {
	MENUOPERATIONS = 'MenuOperations',
	MENUTABS = 'MenuTabs'
}

export const TABS = {
	[TAB_NAMES.MENUOPERATIONS]: { id: TAB_NAMES.MENUOPERATIONS, labelKey: TAB_NAMES.MENUOPERATIONS },
	[TAB_NAMES.MENUTABS]: { id: TAB_NAMES.MENUTABS, labelKey: TAB_NAMES.MENUTABS },
};
